import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-daily-report-popover',
  templateUrl: './daily-report-popover.component.html',
  styleUrls: ['./daily-report-popover.component.scss'],
})
export class DailyReportPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
